import React, { useState } from "react"
import Formsy from "formsy-react"
import { useBackfillReportableFieldContext } from "contexts/BackfillReportableFieldContext"
import * as API from "services/api"
import { TertiaryButton } from "shared/buttons"
import { successToast, errorToast } from "shared/toast"
import BackfillReportableFieldFormCategory from "./BackfillReportableFieldFormCategory"
import BackfillReportableFieldFormForm from "./BackfillReportableFieldFormForm"
import BackfillReportableFieldFormQuestion from "./BackfillReportableFieldFormQuestion"
import BackfillReportableFieldFormReportableField from "./BackfillReportableFieldFormReportableField"

const BACKFILL_REPORTABLE_FIELD_FORM_ID = "backfill-reportable-field-form"

const BackfillReportableFieldForm = () => {
  const [formIsValid, setFormIsValid] = useState(false)

  const { deselectSelections, organizationSubdomain } = useBackfillReportableFieldContext()

  const disableSubmit = () => setFormIsValid(false)
  const enableSubmit = () => setFormIsValid(true)

  const submit = async (model) => {
    const {
      categoryId, formId, questionUuid, reportableFieldId,
    } = model

    const response = await API.phpBackfillCategoryReportableField({
      categoryId, formId, organizationSubdomain, questionUuid, reportableFieldId,
    })

    if (response.ok) {
      successToast("Backfill reportable field scheduled successfully.")
      deselectSelections()
    } else {
      errorToast("Something went wrong.  Unable to backfill reportable field.")
    }
  }

  return (
    <Formsy
      id={BACKFILL_REPORTABLE_FIELD_FORM_ID}
      onInvalid={disableSubmit}
      onSubmit={submit}
      onValid={enableSubmit}
    >
      <BackfillReportableFieldFormCategory />
      <BackfillReportableFieldFormReportableField />
      <BackfillReportableFieldFormForm />
      <BackfillReportableFieldFormQuestion />
      <TertiaryButton
        ariaLabel="submit request to backfill reportable field"
        disabled={!formIsValid}
        form={BACKFILL_REPORTABLE_FIELD_FORM_ID}
        text="Submit"
        type="submit"
      />
    </Formsy>
  )
}

export default BackfillReportableFieldForm
